import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { CustomerServiceNote, CustomerServiceNoteDetail } from '@uzurv/clara';

@Component({
  selector: 'app-trip-notes-detail',
  templateUrl: './trip-notes-detail.component.html',
  styleUrls: ['./trip-notes-detail.component.scss']
})
export class TripNotesDetailComponent implements OnChanges, AfterViewInit {
  @Input() testingIdAccessor: Array<string>;
  @Input() customerServiceNotes: Array<CustomerServiceNoteDetail | CustomerServiceNote>;

  @Output() addNote = new EventEmitter<CustomerServiceNote>();
  @Output() addPage = new EventEmitter<number>();

  @ViewChild('noteScrollArea', { static: true }) noteScrollArea: ElementRef;

  scrollHeight: number = null;
  newNotes = false;

  newNoteForm = this.fb.group({
    text: ['']
  });

  constructor(private cd: ChangeDetectorRef, private fb: UntypedFormBuilder) {}
  ngAfterViewInit() {
    this.scrollHeight = this.noteScrollArea ? this.noteScrollArea.nativeElement.scrollHeight : 0;
    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (this.noteScrollArea &&
        this.noteScrollArea.nativeElement.scrollHeight - this.noteScrollArea.nativeElement.offsetHeight ===
          this.noteScrollArea.nativeElement.scrollTop) ||
      changes['customerServiceNotes']
    ) {
      setTimeout(() => {
        this.scrollHeight = this.noteScrollArea ? this.noteScrollArea.nativeElement.scrollHeight : 0;
        this.cd.detectChanges();
      });
    } else {
      this.newNotes = true;
    }
  }

  onScroll() {
    this.addPage.emit();
  }

  onSubmit() {
    const customerServiceNote = new CustomerServiceNote();
    customerServiceNote.text = this.newNoteForm.get('text').value;
    this.addNote.emit(customerServiceNote);
    this.newNoteForm.get('text').setValue('');
  }
}
